import React from 'react';

export function getNetworkTotalsReports({
  newIsAdmin,
  bonusesResponse,
  variableRevenuesResponse,
  variableRevenuesInsurancesResponse,
  variableRevenuesEnergyResponse,
}) {
  const { bonusesTotals } = bonusesResponse?.value?.data?.totals || {};
  const { variableRevenues, billableVariableRevenues } =
    variableRevenuesResponse?.value?.data?.totals || {};
  const { variableRevenuesInsurance, billableVariableRevenuesInsurance } =
    variableRevenuesInsurancesResponse?.value?.data?.totals || {};
  const { variableRevenuesEnergy, billableVariableRevenuesEnergy } =
    variableRevenuesEnergyResponse?.value?.data?.totals || {};

  const totalNet = newIsAdmin
    ? variableRevenues + variableRevenuesEnergy + variableRevenuesInsurance
    : variableRevenues + variableRevenuesEnergy;

  const billableTotalNet = newIsAdmin
    ? billableVariableRevenues +
      billableVariableRevenuesEnergy +
      billableVariableRevenuesInsurance
    : billableVariableRevenues + billableVariableRevenuesEnergy;

  const total = totalNet + bonusesTotals;
  const billableTotal = billableTotalNet + bonusesTotals;

  return {
    billableTotal,
    billableTotalNet,
    billableVariableRevenues,
    billableVariableRevenuesInsurance,
    billableVariableRevenuesEnergy,
    bonuses: bonusesTotals,
    total,
    totalNet,
    variableRevenues,
    variableRevenuesInsurance,
    variableRevenuesEnergy,
  };
}
